import { colorPalette, supportColorPalette } from '@/assets/colors/palette'
import { CaseStatusEnum, type DisplayableCaseStatus } from '@/citator/schema/case-status-schema'

/**
 * Single source of the inline treatment flag's visual spec, consumed by both
 * renderers — the React component (chat) and the ProseMirror widget (canvas) —
 * which must stay pixel-identical per the design spec.
 *
 * Em-sized to the chat spec's ratios (18px frame / 13.5px glyph at 14px prose)
 * so the flag scales proportionately with each surface's type size.
 */
export const kInlineTreatmentFlagFrameClasses =
  'inline-flex items-center justify-center w-[1.286em] h-[1.286em] cursor-pointer focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand-500 rounded'
export const kInlineTreatmentFlagGlyphClasses = 'w-[0.964em] h-[0.964em]'

/** Shared icon treatment for app renderers and self-contained Word downloads. */
export const kCaseTreatmentVisualsByStatus: Record<DisplayableCaseStatus, { colorClass: string; color: string; filled: boolean }> = {
  [CaseStatusEnum.likely_good]: { colorClass: 'text-true-gray-600', color: colorPalette['true-gray'][600], filled: false },
  [CaseStatusEnum.caution]: { colorClass: 'text-yellow-500', color: supportColorPalette.yellow[500], filled: false },
  // Figma pins overruling risk to Orange/400 (#FB923C), unlike the tag's orange-800-on-100 chip.
  [CaseStatusEnum.overruling_risk]: { colorClass: 'text-orange-400', color: '#FB923C', filled: true },
  [CaseStatusEnum.likely_bad]: { colorClass: 'text-red-500', color: supportColorPalette.red[500], filled: true },
}
